/* unplugin-vue-components disabled */import { render } from "./newDisc.vue?vue&type=template&id=0331e663&scoped=true&ts=true"
import script from "./newDisc.vue?vue&type=script&lang=ts"
export * from "./newDisc.vue?vue&type=script&lang=ts"

import "./newDisc.vue?vue&type=style&index=0&id=0331e663&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0331e663"],['__file',"src/views/latestMusic/cpns/newDisc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0331e663"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0331e663', __exports__)) {
    console.log('reload')
    api.reload('0331e663', __exports__)
  }
  
  module.hot.accept("./newDisc.vue?vue&type=template&id=0331e663&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0331e663', render)
  })

}


export default __exports__